module.exports = __webpack_public_path__ + "static/media/r10.f763fea0.png";